import { saga } from '../../businessRules/saga'

import { userDone } from '../actions/newUser'
import { addUser, modifyUser } from '../actions/users'

export const newUserSaga = user => saga([addUser(user), userDone()])
export const modifyUserSaga = user => saga([modifyUser(user), userDone()])
export const cancelUserSaga = user => saga([userDone()])
